import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';


const LinkSwitch = props => (/^(f|ht)tps?:\/\//i.test(props.url) ? (
  <a {...props} href={props.url}>
    {props.children}
  </a>
) : (
  <Link {...props} to={props.url}>
    {props.children}
  </Link>));

LinkSwitch.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
};

LinkSwitch.defaultProps = {
  url: '',
  children: null,
};

export default LinkSwitch;



// WEBPACK FOOTER //
// ./frontend/js/Components/Util/LinkSwitch/LinkSwitch.jsx